"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBAPICardsCarousel;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/esnext.iterator.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _Carousel = _interopRequireDefault(require("react-bootstrap/Carousel"));
var _svbReactComponents = require("@svb/svb-react-components");
var _helpers = require("./helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function SVBAPICardsCarousel(props) {
  const {
    slide,
    apisJson,
    cardOptions,
    apiCardsData
  } = props;
  const [slideCount, setSlideCount] = (0, _react.useState)(0);
  const [currentIndex, setCurrentIndex] = (0, _react.useState)(0);
  const [isSmallScreen, setisSmallScreen] = (0, _react.useState)(false);
  const [isiPhone, setisiPhone] = (0, _react.useState)(false);
  const [slideiPad, setSlideiPad] = (0, _react.useState)(2);
  const cWindowSize = (0, _helpers.getWindowSize)();
  const cardsSectionOption = apiCardsData.cardsOption;
  const carouselViewAll = cardsSectionOption && cardsSectionOption.viewAll && /*#__PURE__*/_react.default.createElement("div", {
    className: "viewall-btn",
    "data-testid": apiCardsData.apiSectionlabel ? apiCardsData.apiSectionlabel + '-view-all' : 'homepage-api-view-all'
  }, cardsSectionOption.viewAllLink ? /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBButton, {
    text: "All APIs",
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    icon: "right-arrow",
    iconSide: "right",
    onClick: () => window.location.href = cardsSectionOption.viewAllLink
  }) : /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBButton, {
    text: "All APIs",
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    icon: "right-arrow",
    iconSide: "right",
    onClick: () => window.location.href = 'apis/docs-home'
  }));

  // const cardColumn = 12 / slide;
  const reduceCards = (acc, cur, index) => {
    const groupIndex = Math.floor(index / slide);
    if (!acc[groupIndex]) acc[groupIndex] = [];
    acc[groupIndex].push(cur);
    return acc;
  };
  const reduceCardsiPad = (acc, cur, index) => {
    const groupIndex = Math.floor(index / slideiPad);
    if (!acc[groupIndex]) acc[groupIndex] = [];
    acc[groupIndex].push(cur);
    return acc;
  };
  const ref = (0, _react.useRef)(null);
  const onPrevClick = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      ref.current.prev();
    }
  };
  const onNextClick = () => {
    if (currentIndex < slideCount - 1) {
      setCurrentIndex(currentIndex + 1);
      ref.current.next();
    }
  };
  const cardCount = () => {
    const sliderItems = apisJson.reduce(reduceCards, []);
    setSlideCount(Math.ceil(sliderItems.length));
  };
  const cardCountMobile = () => {
    const sliderItems = apisJson.reduce(reduceCardsiPad, []);
    setSlideCount(Math.ceil(sliderItems.length));
  };
  (0, _react.useEffect)(() => {
    const iPadRes = window.innerWidth;
    if (iPadRes >= 1025) {
      setSlideiPad(3);
      setisSmallScreen(false);
      cardCount();
    } else if (iPadRes >= 768 && iPadRes <= 1024) {
      setSlideiPad(2);
      setisSmallScreen(true);
      cardCountMobile();
    } else {
      setisSmallScreen(true);
      setisiPhone(true);
      setSlideiPad(1);
      cardCountMobile();
    }
  }, [cWindowSize === null || cWindowSize === void 0 ? void 0 : cWindowSize.width]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: isiPhone ? 'd-flex flex-row justify-content-between pt-4' : 'row pt-4'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cards col-12 col-md-12 px-2 px-md-3 px-lg-0"
  }, /*#__PURE__*/_react.default.createElement(_Carousel.default, {
    bsPrefix: "carousel",
    indicators: false,
    interval: null,
    ref: ref,
    controls: false
  }, apisJson.reduce(isSmallScreen ? reduceCardsiPad : reduceCards, []).map((item, index) => /*#__PURE__*/_react.default.createElement(_Carousel.default.Item, {
    key: index
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, item.map((item, index) => {
    const btnLink = item.link ? item.link : "/apis/".concat(item.api_name, "/").concat(item.version);
    const btnText = cardOptions !== null && cardOptions !== void 0 && cardOptions.overrideLearnMoreElement ? cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.overrideLearnMoreElement : item.buttonLabel ? item.buttonLabel : 'Learn more';
    const cardTestid = (0, _helpers.slugCreator)('card-' + item.api_name);
    const learnMoreTestid = (0, _helpers.slugCreator)(btnText + '-' + item.api_name);
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: isSmallScreen ? 'col-md-6 col-sm-12 align-item-stretch d-flex mb-4' : 'col-md-4 col-sm-12 align-item-stretch d-flex mb-4'
    }, /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBCard, {
      cardIcon: item.cardIcon,
      description: item.api_description,
      title: item.api_display_name,
      link: btnLink,
      buttonLabel: btnText,
      cardOptions: cardOptions,
      datatestid: {
        card: cardTestid,
        learnMore: learnMoreTestid
      }
    }));
  })))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-between align-items-center carousel-control-area"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex carousel-next-prev align-items-center gap-3"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: currentIndex === 0 ? 'svb-carousel-control-prev-wrapper disabled ' : ' svb-carousel-control-prev-wrapper',
    onClick: onPrevClick
  }, /*#__PURE__*/_react.default.createElement("i", {
    class: "fa-solid fa-arrow-left"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: currentIndex === slideCount - 1 ? 'svb-carousel-control-next-wrapper disabled' : 'svb-carousel-control-next-wrapper',
    onClick: onNextClick
  }, /*#__PURE__*/_react.default.createElement("i", {
    class: "fa-solid fa-arrow-right"
  }))), carouselViewAll && carouselViewAll));
}